import { render, staticRenderFns } from "./DealifyForm.vue?vue&type=template&id=cdf169d4&scoped=true"
import script from "./DealifyForm.vue?vue&type=script&lang=js"
export * from "./DealifyForm.vue?vue&type=script&lang=js"
import style0 from "./DealifyForm.vue?vue&type=style&index=0&id=cdf169d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf169d4",
  null
  
)

export default component.exports